// Custom JS/jQuery add here

// if (window.location.href.indexOf("product") > -1) {}
// if (/products/.test(window.location.href)){}

if (window.matchMedia('(max-width: 768px)').matches) {
    var elem = document.querySelector('.custom_product-slideshow');
    var flkty = new Flickity( elem, {
      cellAlign: 'left',
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false 
    });
   var progressBar = document.querySelector('.progress-bar')
   flkty.on( 'scroll', function( progress ) {
      progress = Math.max( 0, Math.min( 1, progress ) );       
      progressBar.style.width = progress * 100 + '%';       
   });
}

// Announcement bar scrolling effect start: Ticker
var flktyAnnouncement;
var flktyMarqueeSpeedAdjustment = 1.5;
if(window.screen.width < 769){
  flktyMarqueeSpeedAdjustment = 0.7;
}

function update(){
  flktyAnnouncement.x = (flktyAnnouncement.x - flktyMarqueeSpeedAdjustment) % flktyAnnouncement.slideableWidth;
  flktyAnnouncement.settle(flktyAnnouncement.x);
  window.requestAnimationFrame(update);
}

// const listCount = document.getElementById('AnnouncementSlider1').getElementById('.announcement-slider__slide');
const announcementListCount = document.getElementById('AnnouncementSlider1').getElementsByTagName('div');

// if(announcementListCount.length > 2){
var announcementSlider = document.querySelector('#AnnouncementSlider1');
flktyAnnouncement = new Flickity( announcementSlider, {
  autoPlay: false,  
  pageDots: false,
  wrapAround: true,
  prevNextButtons: false  
});
flktyAnnouncement.x = 0;
  update();
// }

// Announcement bar scrolling effect Ends

// Adding class when hover on menu items
// $(".is-light .site-header .site-nav__item").hover(
$(".is-light .site-header").hover(
  function () {
    $(".is-light .site-header").addClass("focused-menu");
  },
  function () {
    $(".is-light .site-header").removeClass("focused-menu");
  }
);

// Pages Sticky tabs
$(window).scroll(function() {
  var headerHeight = $('header').outerHeight();
    if($('.site-header').hasClass("site-header--stuck")){
      $(".page-full.page_tab_menus, .template-collection .boost-pfs-filter-left-col.grid__item.medium-up--one-fifth, div#boost-pfs-filter-tree2[data-is-mobile]")
        .css({"position": "sticky", "top": headerHeight, "background": "#fff" });
    }else{
      $(".page-full.page_tab_menus, .template-collection .boost-pfs-filter-left-col.grid__item.medium-up--one-fifth, div#boost-pfs-filter-tree2[data-is-mobile]")
        .css({"position": "relative", "top": "0" });
    }
});

// var width = $(window).width();
// if (width < 769){
//   var collectionFilter = document.querySelector('.template-collection .filter-form ul.tag-list');
//   var collectionFilterFlkty = new Flickity( collectionFilter, {
//     cellAlign: 'left',
//     wrapAround: false,
//     pageDots: false,
//     prevNextButtons: false
//   });
// }
// setTimeout( function(){  }, 500);


// ----------------------------------
// Free Shipping Progress + Free Gift
// (Impulse / Archetype)
// ----------------------------------
let giftBusy = false;

// ----------------------------
// Helpers
// ----------------------------
function isSupportedCountry(wrapper) {
  const allowed = (wrapper.dataset.supportedCountries || "")
    .split(",")
    .map(s => s.trim().toUpperCase())
    .filter(Boolean);

  const country = (wrapper.dataset.country || "").toUpperCase();

  // If merchant leaves setting empty → allow all
  if (!allowed.length) return true;

  return allowed.includes(country);
}

function getGiftHandles(wrapper) {
  return parseHandles(wrapper.dataset.giftHandles);
}

function ensureGiftAccordion(chooser) {
  const toggle = chooser.querySelector(".gift-chooser__toggle");
  const panel = chooser.querySelector(".gift-chooser__panel");
  if (!toggle || !panel || toggle.__bound) return;

  toggle.__bound = true;

  toggle.addEventListener("click", () => {
    const isOpen = chooser.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    panel.hidden = !isOpen;
  });

  // Default open
  chooser.classList.add("is-open");
  toggle.setAttribute("aria-expanded", "true");
  panel.hidden = false;
}

function formatMoney(cents, format) {
  const fmt = format || "{{amount}}";
  const amount = cents / 100;

  const formatWithSeparators = (val, decimals, decimalSep, thousandSep) => {
    const number = val.toFixed(decimals);
    const parts = number.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
    return parts.join(decimalSep);
  };

  return fmt
    .replace("{{amount_no_decimals_with_comma_separator}}", formatWithSeparators(amount, 0, ",", "."))
    .replace("{{amount_with_comma_separator}}", formatWithSeparators(amount, 2, ",", "."))
    .replace("{{amount_no_decimals}}", formatWithSeparators(amount, 0, ".", ","))
    .replace("{{amount}}", formatWithSeparators(amount, 2, ".", ","));
}

function parseMap(str) {
  const map = {};
  (str || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .forEach((pair) => {
      const [k, v] = pair.split(":");
      const num = parseFloat(v);
      if (k && Number.isFinite(num)) map[k.toUpperCase()] = num;
    });
  return map;
}

function getMultiplier(currency) {
  return ["JPY","KRW","CLP","HUF","TWD"].includes(currency) ? 1 : 100;
}

function resolveThreshold(wrapper, datasetKey, currency) {
  const cur = (currency || "").toUpperCase();
  const map = parseMap(wrapper.dataset[datasetKey]);

  const countrySupported = isSupportedCountry(wrapper);

  // If country NOT supported → always use INT (if present)
  if (!countrySupported) {
    const intlMajor = map["INT"];
    if (!Number.isFinite(intlMajor)) return null;

    // INT values are written in "major" units like 350.00 -> minor units
    return Math.round(intlMajor * getMultiplier(cur || "USD"));
  }  

  // Country supported → use currency map
  const major = map[cur];
  if (!Number.isFinite(major)) return null;

  return Math.round(major * getMultiplier(cur));
}

function parseHandles(str) {
  return (str || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

function isGiftLine(item) {
  if (!item || !item.properties) return false;
  const v = item.properties._free_gift;
  return v === true || v === "true" || v === 1 || v === "1";
}

function findGift(cart) {
  return (cart.items || []).find(isGiftLine) || null;
}

// Exclude gift from totals so the gift can’t keep itself eligible
function getCartTotalExcludingGift(cart) {
  const gift = findGift(cart);
  if (!gift) return cart.total_price;
  return cart.total_price - (gift.final_line_price || 0);
}

// Threshold markers
function formatMoneyMarker(cents, format) {
  if (!Number.isFinite(cents)) return "";

  const amount = cents / 100;

  let formatted = format || "{{amount}}";

  // Handle Shopify money tokens
  formatted = formatted
    .replace("{{amount_no_decimals}}", amount.toFixed(0))
    .replace("{{amount}}", amount.toFixed(2))
    .replace("{{amount_with_comma_separator}}", amount.toFixed(2).replace(".", ","))
    .replace("{{amount_no_decimals_with_comma_separator}}", amount.toFixed(0));

  // Strip HTML wrappers (Impulse dualPrice etc)
  const tmp = document.createElement("div");
  tmp.innerHTML = formatted;
  formatted = tmp.textContent || tmp.innerText || formatted;

  // Remove trailing decimals (€,00 or .00)
  formatted = formatted.replace(/([.,])00\b/, "");

  return formatted.trim();
}

function updateProgressMarkers(wrapper, shipThresholdMinor, giftThresholdMinor, moneyFormat) {
  const markersWrap = wrapper.querySelector(".cart-progress-markers");
  if (!markersWrap) return;

  const shipMarker = markersWrap.querySelector(".cart-progress-marker--ship");
  const giftMarker = markersWrap.querySelector(".cart-progress-marker--gift");
  const shipLabel = shipMarker && shipMarker.querySelector(".cart-progress-marker__label");
  const giftLabel = giftMarker && giftMarker.querySelector(".cart-progress-marker__label");

  const hasGift = Number.isFinite(giftThresholdMinor) && giftThresholdMinor > 0;

  // If no gift stage, ship is the "end"
  const max = hasGift ? giftThresholdMinor : shipThresholdMinor;

  if (!Number.isFinite(max) || max <= 0) {
    markersWrap.style.display = "none";
    return;
  }

  markersWrap.style.display = "";

  // Show/hide gift marker
  if (giftMarker) giftMarker.style.display = hasGift ? "" : "none";

  // Positions
  const shipPct = Math.max(0, Math.min((shipThresholdMinor / max) * 100, 100));
  if (shipMarker) shipMarker.style.left = `${shipPct}%`;

  // Labels
  if (shipLabel) shipLabel.textContent = formatMoneyMarker(shipThresholdMinor, moneyFormat);

  if (giftLabel) {
    giftLabel.textContent = hasGift
      ? formatMoneyMarker(giftThresholdMinor, moneyFormat)
      : "";
  }
}

// ----------------------------
// Cart API
// ----------------------------
function cartChange(lineKey, quantity) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: lineKey, quantity }),
  }).then((r) => r.json());
}

function addGift(variantId) {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: { _free_gift: "true" },
    }),
  }).then((r) => r.json());
}

// ----------------------------
// Gift UI
// ----------------------------
function bindGiftSlider(wrapper) {
  const options = wrapper.querySelector(".gift-chooser__options");
  const nav = wrapper.querySelector(".gift-chooser__nav");
  const prev = wrapper.querySelector(".gift-chooser__arrow--prev");
  const next = wrapper.querySelector(".gift-chooser__arrow--next");

  if (!options || !prev || !next) return;

  // Bind click handlers once per wrapper
  if (!wrapper.__sliderBound) {
    wrapper.__sliderBound = true;

    const scrollByCard = () => {
      const card = options.querySelector(".gift-chooser__card");
      // +10 matches your gap
      return card ? card.getBoundingClientRect().width + 10 : 220;
    };

    prev.addEventListener("click", () => {
      options.scrollBy({ left: -scrollByCard(), behavior: "smooth" });
    });

    next.addEventListener("click", () => {
      options.scrollBy({ left: scrollByCard(), behavior: "smooth" });
    });
  }

  const updateUI = () => {
    // Do we actually overflow?
    const maxScroll = options.scrollWidth - options.clientWidth;
    const hasOverflow = maxScroll > 1;

    // Show/hide nav only if needed
    if (nav) nav.hidden = !hasOverflow;

    if (!hasOverflow) {
      // reset states
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    // Enable/disable based on current scroll
    prev.disabled = options.scrollLeft <= 0;
    next.disabled = options.scrollLeft >= maxScroll - 1;
  };

  // Bind listeners once
  if (!options.__sliderListenersBound) {
    options.__sliderListenersBound = true;
    options.addEventListener("scroll", updateUI);
    window.addEventListener("resize", () => {
      // Wait a tick for layout to settle
      requestAnimationFrame(updateUI);
    });
  }

  // Run after render/layout
  requestAnimationFrame(() => {
    updateUI();
  });
}

function updateGiftUI(wrapper, cart, currency) {
  const chooser = wrapper.querySelector(".gift-chooser");
  const options = wrapper.querySelector(".gift-chooser__options");
  if (!chooser || !options) return;

  const giftHandles = getGiftHandles(wrapper);

  if (!giftHandles.length) {
    chooser.hidden = true;
    options.innerHTML = "";
    delete options.dataset.rendered;
    chooser.classList.remove("is-open", "is-locked");
    chooser.dataset.wasEligible = "false";
    return;
  }  

  ensureGiftAccordion(chooser);

  const titleEl = chooser.querySelector(".gift-chooser__title");
  const lockedTpl = titleEl?.dataset.lockedText || "";
  const unlockedText = titleEl?.dataset.unlockedText || "";

  const moneyFormat = wrapper.dataset.moneyFormat || "{{amount}}";
  const giftThreshold = resolveThreshold(wrapper, "giftThresholds", currency);

  // Missing config -> hide entire gift section
  if (!Number.isFinite(giftThreshold) || !giftHandles.length) {
    chooser.hidden = true;
    options.innerHTML = "";
    delete options.dataset.rendered;
    chooser.classList.remove("is-locked", "is-open");
    chooser.dataset.wasEligible = "false";
    return;
  }

  // Config exists -> show gift section always
  chooser.hidden = false;

  const effectiveTotal = getCartTotalExcludingGift(cart);
  const eligible = effectiveTotal >= giftThreshold;
  const existingGift = findGift(cart);

  const remainingForGift = Math.max(giftThreshold - effectiveTotal, 0);
  const remainingForGiftFormatted = formatMoney(remainingForGift, moneyFormat);

  const toggle = chooser.querySelector(".gift-chooser__toggle");
  const panel = chooser.querySelector(".gift-chooser__panel");

  // ----------------------------
  // LOCKED
  // ----------------------------
  if (!eligible) {
    chooser.classList.add("is-locked");
    if (titleEl) {
      const targetGoalFormatted = formatMoney(giftThreshold, moneyFormat);
      const remainingFormatted = remainingForGiftFormatted;

      let lockedText = lockedTpl
        .replace("[remaining_for_gift]", `<strong>${remainingFormatted}</strong>`)
        .replace("[target_goal]", `<strong>${targetGoalFormatted}</strong>`);

      titleEl.innerHTML = lockedText;
    }

    // Mark not eligible so "open once" will work later
    chooser.dataset.wasEligible = "false";
    chooser.dataset.userClosed = "false"; // reset

    // Keep accordion closed by default while locked
    if (panel && toggle) {
      chooser.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      panel.hidden = true;
    }

    // Render cards once (greyed by CSS via .is-locked)
    if (options.dataset.rendered !== "locked" && options.dataset.rendered !== "unlocked") {
      options.dataset.rendered = "locked";
      options.innerHTML = `<div class="gift-loading">Loading...</div>`;

      Promise.all(
        giftHandles.map((h) =>
          fetch(`/products/${h}.js`).then((r) => r.json()).catch(() => null)
        )
      )
        .then((products) => {
          const valid = (products || []).filter(Boolean);
          if (!valid.length) {
            chooser.hidden = true;
            options.innerHTML = "";
            delete options.dataset.rendered;
            return;
          }

          options.innerHTML = valid
            .map((p) => {
              const v =
                (p.variants || []).find((vv) => vv.available) || (p.variants || [])[0];
              if (!v || !v.id) return "";

              const img = p.featured_image || (p.images && p.images[0]) || "";
              const label = p.title || p.handle;

              return `
                <button type="button" class="gift-chooser__card" data-variant="${v.id}" tabindex="-1" aria-disabled="true">
                  <span class="gift-chooser__imgwrap">
                    ${img ? `<img src="${img}" alt="${label}" loading="lazy">` : ""}
                  </span>
                </button>
              `;
            })
            .join("");

          bindGiftSlider(wrapper);
        })
        .catch(() => {});
    }

    // Remove existing gift if present
    if (existingGift && !giftBusy) {
      giftBusy = true;
      cartChange(existingGift.key, 0)
        .then(() => {
          document.dispatchEvent(new CustomEvent("cart:build"));
          setTimeout(fetchCartAndUpdate, 250);
        })
        .catch(() => {})
        .finally(() => {
          giftBusy = false;
        });
    }

    return;
  }

  // ----------------------------
  // UNLOCKED / ELIGIBLE
  // ----------------------------
  chooser.classList.remove("is-locked");
  if (titleEl) titleEl.innerHTML = unlockedText;

  // Auto-open once when they *cross* the threshold (unless user closed it)
  if (panel && toggle) {
    const wasEligible = chooser.dataset.wasEligible === "true";
    const userClosed = chooser.dataset.userClosed === "true";

    if (!wasEligible && !userClosed) {
      chooser.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      panel.hidden = false;
    }

    chooser.dataset.wasEligible = "true";
  }

  // Render options once per wrapper rebuild
  if (options.dataset.rendered === "unlocked") return;

  options.innerHTML = `<div class="gift-loading">Loading...</div>`;

  Promise.all(
    giftHandles.map((h) =>
      fetch(`/products/${h}.js`).then((r) => r.json()).catch(() => null)
    )
  )
    .then((products) => {
      const valid = (products || []).filter(Boolean);
      if (!valid.length) {
        chooser.hidden = true;
        options.innerHTML = "";
        delete options.dataset.rendered;
        return;
      }

      options.innerHTML = valid
        .map((p) => {
          const v =
            (p.variants || []).find((vv) => vv.available) || (p.variants || [])[0];
          if (!v || !v.id) return "";

          const img = p.featured_image || (p.images && p.images[0]) || "";
          const label = p.title || p.handle;

          return `
            <button type="button" class="gift-chooser__card" data-variant="${v.id}">
              <span class="gift-chooser__imgwrap">
                ${img ? `<img src="${img}" alt="${label}" loading="lazy">` : ""}
              </span>
            </button>
          `;
        })
        .join("");

      bindGiftSlider(wrapper);

      // Ensure single click handler
      if (options.__giftHandler) {
        options.removeEventListener("click", options.__giftHandler);
      }

      options.__giftHandler = (e) => {
        const btn = e.target.closest("[data-variant]");
        if (!btn) return;

        e.preventDefault();

        // If somehow locked, do nothing
        if (chooser.classList.contains("is-locked")) return;

        if (giftBusy) return;
        giftBusy = true;
        btn.disabled = true;

        const variantId = parseInt(btn.dataset.variant, 10);
        if (!variantId) {
          giftBusy = false;
          btn.disabled = false;
          return;
        }

        fetch("/cart.js")
          .then((r) => r.json())
          .then((c) => {
            const existing = findGift(c);

            // Same selection -> no-op
            if (existing && existing.variant_id === variantId) return null;

            // Swap: remove old gift then add new gift
            if (existing) {
              return cartChange(existing.key, 0).then(() => addGift(variantId));
            }
            return addGift(variantId);
          })
          .then(() => {
            document.dispatchEvent(new CustomEvent("cart:build"));
            setTimeout(fetchCartAndUpdate, 250);
          })
          .catch(() => {})
          .finally(() => {
            giftBusy = false;
            btn.disabled = false;
          });
      };

      options.addEventListener("click", options.__giftHandler);
      options.dataset.rendered = "unlocked";
    })
    .catch(() => {
      chooser.hidden = true;
      options.innerHTML = "";
      delete options.dataset.rendered;
    });
}

// ----------------------------
// Progress Bars (drawer + page)
// ----------------------------
function updateProgressBars(cart, currency) {
  document.querySelectorAll("#cart-progress-wrapper").forEach((wrapper) => {
    const bar = wrapper.querySelector("#cart-progress-bar");
    const msg = wrapper.querySelector(".goal-message");

    const moneyFormat = wrapper.dataset.moneyFormat || "{{amount}}";

    const preTpl      = wrapper.dataset.preGoalMessageTemplate || "";
    const midTpl      = wrapper.dataset.midGoalMessageTemplate || "";
    const postGoalMsg = wrapper.dataset.postGoalMessage || "";
    const postShipMsg = wrapper.dataset.postShipMessage || ""; // data-post-ship-message

    // Thresholds (now with INT fallback if currency missing)
    const shipThreshold = resolveThreshold(wrapper, "thresholds", currency);
    const giftThreshold = resolveThreshold(wrapper, "giftThresholds", currency);

    // Empty cart OR no shipping threshold → hide module
    if (!cart.item_count || !Number.isFinite(shipThreshold) || shipThreshold <= 0) {
      wrapper.classList.remove("is-visible", "full");
      if (bar) bar.style.width = "0%";
      if (msg) msg.innerHTML = "";

      const markersWrap = wrapper.querySelector(".cart-progress-markers");
      if (markersWrap) markersWrap.style.display = "none";

      const chooser = wrapper.querySelector(".gift-chooser");
      const options = wrapper.querySelector(".gift-chooser__options");
      if (chooser) {
        chooser.hidden = true;
        chooser.classList.remove("is-open", "is-locked");
        chooser.dataset.wasEligible = "false";
      }
      if (options) {
        options.innerHTML = "";
        delete options.dataset.rendered;
      }
      return;
    }

    wrapper.classList.add("is-visible");

    // Exclude gift line from totals
    const effectiveTotal = getCartTotalExcludingGift(cart);

    // Gift is enabled if handles exist AND gift threshold exists
    const giftHandles = getGiftHandles(wrapper);

    const giftEnabled =
      giftHandles.length > 0 &&
      Number.isFinite(giftThreshold) &&
      giftThreshold > 0;

    wrapper.classList.toggle("shipping-only", !giftEnabled);

    const finalGoal = giftEnabled ? giftThreshold : shipThreshold;

    // Markers (hide gift marker automatically when giftEnabled=false)
    updateProgressMarkers(wrapper, shipThreshold, giftEnabled ? giftThreshold : null, moneyFormat);

    // Bar fill
    const pct = Math.min((effectiveTotal / finalGoal) * 100, 100);
    if (bar) bar.style.width = `${pct}%`;
    wrapper.classList.toggle("full", pct >= 100);

    // Messages
    let message = "";

    if (effectiveTotal < shipThreshold) {
      const remaining = shipThreshold - effectiveTotal;
      const formatted = formatMoney(remaining, moneyFormat);
      message = preTpl.replace("[remaining_for_goal]", `<strong>${formatted}</strong>`);
    } else if (giftEnabled && effectiveTotal < giftThreshold) {
      const remaining = giftThreshold - effectiveTotal;
      const formatted = formatMoney(remaining, moneyFormat);
      message = midTpl.replace("[remaining_for_goal]", `<strong>${formatted}</strong>`);
    } else {
      // Reached shipping (and gift if enabled)
      message = giftEnabled ? postGoalMsg : (postShipMsg || postGoalMsg);
    }

    if (msg) msg.innerHTML = message;

    // Gift UI
    const chooser = wrapper.querySelector(".gift-chooser");
    const options = wrapper.querySelector(".gift-chooser__options");

    if (giftEnabled) {
      if (typeof updateGiftUI === "function") updateGiftUI(wrapper, cart, currency);
    } else {
      if (chooser) {
        chooser.hidden = true;
        chooser.classList.remove("is-open", "is-locked");
        chooser.dataset.wasEligible = "false";
      }
      if (options) {
        options.innerHTML = "";
        delete options.dataset.rendered;
      }
    }
  });
}

// ----------------------------
// Fetch + Events
// ----------------------------
function fetchCartAndUpdate() {
  return fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {
      updateProgressBars(cart, cart.currency);
      return cart;
    })
    .catch(() => {});
}

document.addEventListener("DOMContentLoaded", fetchCartAndUpdate);

document.addEventListener("cart:updated", (e) => {
  const c = e.detail && e.detail.cart;
  if (c && typeof c.total_price !== "undefined") {
    updateProgressBars(c, c.currency);
  } else {
    fetchCartAndUpdate();
  }
});

document.addEventListener("ajaxProduct:added", () => {
  document.dispatchEvent(new CustomEvent("cart:build"));
  setTimeout(fetchCartAndUpdate, 250);
});